import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import useApi from "../../api";
import config from "../../config";
import Button from "../Button";
import Filters from "../../pages/explore/search/components/Filters";
import LotNavigation from "./Navigation/LotNavigation";
import ReleaseNavigation from "./Navigation/ReleaseNavigation";
import "./Navigation.scss";
var isJubilee = window.location.host.includes("myjubilee.com.au");
export var Navigation = function Navigation(a) {
  var b = a.title,
      c = a.menu,
      d = a.hovered,
      e = a.onHover,
      f = a.release,
      g = a.lot,
      h = a.assetPath,
      i = a.showFilters,
      j = a.noAdvancedSearch,
      k = a.isResultPage,
      l = useApi(),
      m = l.current.apartments.length,
      n = l.current.townhomes.length,
      o = l.current.packages.length,
      p = useState(i || !1),
      q = _slicedToArray(p, 2),
      r = q[0],
      s = q[1],
      t = function onMouseEnter(a) {
    "function" == typeof e && e(a);
  },
      u = function onMouseLeave() {
    "function" == typeof e && e(null);
  };

  c = c.filter(function (a) {
    var b = a.status;
    return void 0 === b || 1 === b || 3 === b || 4 === b;
  });
  var v = f,
      w = g,
      x = null,
      y = [],
      z = [];
  c.map(function (a) {
    var b = a.lots ? a.lots.filter(function (a) {
      var b = a.status;
      return 1 === b || 3 === b;
    }).length : 0;
    return 0 === b ? y.push(a) : z.push(a), null;
  }), c = z.concat(y), x = w ? /*#__PURE__*/React.createElement(LotNavigation, {
    release: f,
    lot: g,
    assetPath: h
  }) : v ? /*#__PURE__*/React.createElement(ReleaseNavigation, {
    menu: c,
    title: b,
    hovered: d,
    onMouseEnter: t,
    onMouseLeave: u
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", null, c.map(function (a, b) {
    var c = a.name,
        e = a.slug,
        f = a.href,
        g = a.lots,
        h = classnames({
      active: e === d
    }),
        i = g ? g.filter(function (a) {
      var b = a.status;
      return 1 === b || 3 === b;
    }).length : 0; // if(availableLots > 0) {

    return /*#__PURE__*/React.createElement("li", {
      key: "default-nav-".concat(b),
      className: h,
      onMouseEnter: function onMouseEnter() {
        return t(e);
      },
      onMouseLeave: function onMouseLeave() {
        return u(e);
      }
    }, /*#__PURE__*/React.createElement(Link, {
      to: f,
      className: "lfs--nav--link"
    }, c, i ? " (".concat(i, " lots)") : null, " ", 0 === i && /*#__PURE__*/React.createElement("span", {
      className: "lots-available sold",
      style: {
        color: "#ba0d2f"
      }
    }, "(Sold Out)"))); // }
  })));
  var A;
  return v && (A = f.lots ? f.lots.filter(function (a) {
    var b = a.status;
    return 1 === b || 3 === b;
  }).length : 0), /*#__PURE__*/React.createElement("div", {
    className: "lfs--nav"
  }, !w && /*#__PURE__*/React.createElement("h2", null, b, " ", 0 === A && /*#__PURE__*/React.createElement("span", {
    style: {
      color: "#ba0d2f"
    }
  }, "(Sold Out)"), /*#__PURE__*/React.createElement("button", {
    onClick: function toggleFilter() {
      return s(!r);
    },
    className: "lfs--nav--filter"
  })), /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, !w && r ? /*#__PURE__*/React.createElement(Filters, {
    filters: l.filters,
    onlyLotsFilters: !0,
    isResultPage: void 0 !== k && k,
    noAdvancedSearch: void 0 === j || j,
    showNeibourhood: !1
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "lfs--nav--scroll"
  }, x), !w && /*#__PURE__*/React.createElement("div", {
    className: "lfs--c2as"
  }, !v && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    href: config.routes.get("landforsale.results")
  }, "View all available lots"), isJubilee ? /*#__PURE__*/React.createElement(Button, {
    href: config.routes.get("landforsale.results", "?featured_options=titled"),
    color: "secondary",
    icon: "land",
    size: "large"
  }, "Titled lots") : null, m || n || o ? /*#__PURE__*/React.createElement(Button, {
    href: config.routes.get("property.search"),
    color: "secondary",
    icon: "search",
    size: "large"
  }, "Property search") : null, n ? /*#__PURE__*/React.createElement(Button, {
    href: config.routes.get("townhomes"),
    color: "secondary",
    icon: "apartment",
    size: "large",
    target: "_self",
    external: !0
  }, "View Townhomes") : null, m ? /*#__PURE__*/React.createElement(Button, {
    href: config.routes.get("apartments"),
    color: "secondary",
    icon: "apartment",
    size: "large",
    target: "_self",
    external: !0
  }, "View Apartments") : null), v && /*#__PURE__*/React.createElement(Button, {
    href: h + v.flyer,
    external: !0
  }, "Release Flyer")));
}; // Navigation.propTypes = {};

export default Navigation;